/** @format */

import React, { useState, useEffect } from "react";
import UsersTableView from "./UsersTable.view";
import { IUsers } from "../AccountInfoPage.types";
import { SearchOutlined } from "@ant-design/icons";
import { ColumnProps } from "antd/lib/table";
import { IAccountsListProps } from "../../AccountsOverview/AccountsOverview.types";
import { Input, Button } from "antd";
import Highlighter from "react-highlight-words";

interface IUsersTableContainerProps {
	users: IUsers[];
	fetchAndSetUsers: () => void;
}

const UsersTableContainer: React.FC<IUsersTableContainerProps> = ({
	users,
	fetchAndSetUsers,
}) => {
	const [editedUsers, setEditedUsers] = useState<IUsers[]>([]);
	const [searchText, setSearchText] = useState<string>("");

	useEffect(() => {
		setEditedUsers(users);
	}, [users]);

	const setTheEditedUsers = (editedUsersList) => {
		setEditedUsers(editedUsersList);
	};

	//Search function for table
	const getColumnSearchProps = (
		dataIndex: string
	): {
		filterDropdown: ColumnProps<IAccountsListProps>["filterDropdown"];
		filterIcon: ColumnProps<IAccountsListProps>["filterIcon"];
		onFilter: ColumnProps<IAccountsListProps>["onFilter"];
		render: ColumnProps<IAccountsListProps>["render"];
	} => ({
		filterDropdown: ({
			setSelectedKeys,
			selectedKeys,
			confirm,
			clearFilters,
		}) => {
			if (selectedKeys && setSelectedKeys) {
				return (
					<div style={{ padding: 8 }}>
						<Input
							placeholder={`Search`}
							value={selectedKeys[0]}
							onChange={(e) =>
								setSelectedKeys(e.target.value ? [e.target.value] : [])
							}
							onPressEnter={() => handleSearch(selectedKeys, confirm)}
							style={{ width: 188, marginBottom: 8, display: "block" }}
						/>
						<Button
							type="primary"
							onClick={() => handleSearch(selectedKeys, confirm)}
							icon={<SearchOutlined />}
							size="small"
							style={{ width: 90, marginRight: 8 }}>
							Search
						</Button>
						<Button
							onClick={() => handleReset(clearFilters)}
							size="small"
							style={{ width: 90 }}>
							Reset
						</Button>
					</div>
				);
			}
		},
		filterIcon: (filtered) => (
			<SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
		),
		onFilter: (value, record) =>
			record[dataIndex]
				.toString()
				.toLowerCase()
				.includes(value.toString().toLowerCase()),
		render: (text) => (
			<Highlighter
				highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
				searchWords={[searchText]}
				autoEscape
				textToHighlight={text.toString()}
			/>
		),
	});

	const handleSearch = (selectedKeys, confirm) => {
		confirm();
		setSearchText(selectedKeys[0]);
	};

	const handleReset = (clearFilters) => {
		clearFilters();
		setSearchText("");
	};

	return (
		<div>
			<UsersTableView
				users={users}
				editedUsers={editedUsers}
				setTheEditedUsers={setTheEditedUsers}
				fetchAndSetUsers={fetchAndSetUsers}
				getColumnSearchProps={getColumnSearchProps}
			/>
		</div>
	);
};

export default UsersTableContainer;
